import React from "react";

const Terms: React.FC = () => {
  return (
    <main className="min-h-screen bg-white text-brandNavy py-20">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-6">Terms of Service</h1>

        <p className="text-base text-mutedGray mb-4">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Acceptance of Terms</h2>
          <p className="text-base text-mutedGray">
            By accessing or using our website and services you agree to be bound
            by these Terms of Service.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Use of the Service</h2>
          <p className="text-base text-mutedGray">
            You agree to use the service only for lawful purposes and in
            compliance with all applicable laws and regulations.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Payments & Refunds</h2>
          <p className="text-base text-mutedGray">
            If any paid products or programs are offered, payment terms and
            refund policies will be clearly stated during checkout. Unless
            otherwise specified, refunds are handled according to the stated
            refund policy for the specific product.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Intellectual Property</h2>
          <p className="text-base text-mutedGray">
            All content on the website (text, images, logos, videos) is owned by
            us or our licensors and is protected by copyright. You may not
            reproduce or distribute content without permission.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">
            Limitation of Liability
          </h2>
          <p className="text-base text-mutedGray">
            To the maximum extent permitted by law, we are not liable for any
            indirect, incidental, special or consequential damages arising from
            your use of the site or services.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Changes</h2>
          <p className="text-base text-mutedGray">
            We may update these Terms from time to time. We will post updates on
            this page with a revised "Last updated" date.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Governing Law</h2>
          <p className="text-base text-mutedGray">
            These Terms are governed by the laws of the applicable jurisdiction
            where the business operates.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">Contact</h2>
          <p className="text-base text-mutedGray">
            Questions about these Terms? Please contact us on our Contact page.
          </p>
        </section>

        <p className="text-sm text-mutedGray mt-8">
          These Terms are provided for convenience and basic coverage. For
          complete legal protection tailored to your business, consult a
          qualified attorney.
        </p>
      </div>
    </main>
  );
};

export default Terms;
